import { useEffect, useMemo } from "react";

import classNames from "classnames";
import { Button } from "neetoui";

import { FloatingPopupPlaceholderImage } from "../PlaceholderImages";

const FloatingPopup = ({ iframeURL, customization }) => {
  const { btnTextColor, showIcon, btnText, btnPosition, btnColor, icon } =
    customization;

  /**
   * Currently embed() function doesn't have an unembed handler.
   * When iframe link changes, we don't have an option to reinitiate it.
   * So we forcefully recreate the element with `key` and call embed() again
   */
  const elementSelectorId = useMemo(
    () => `popup-button-${Math.random().toString().substring(2, 10)}`,
    [iframeURL]
  );

  useEffect(() => {
    const element = document.getElementById(elementSelectorId);
    if (!element) return;

    const appName = globalProps.appName.replace(/^neeto/i, "neeto");
    window[appName]?.embed(element, iframeURL);
  }, [iframeURL]);

  useEffect(() => {
    const btn = document.getElementById(elementSelectorId);
    btn.style.backgroundColor = btnColor;
    btn.style.color = btnTextColor;
  }, [btnColor, btnTextColor]);

  return (
    <div className="relative h-full w-full overflow-hidden">
      <FloatingPopupPlaceholderImage className="neeto-ui-text-gray-100 h-auto w-full p-10" />
      <Button
        data-testid="popup-preview-button"
        icon={icon && showIcon ? icon : null}
        iconPosition="left"
        id={elementSelectorId}
        key={elementSelectorId}
        label={btnText}
        className={classNames("absolute bottom-0 m-4", {
          "start-0": btnPosition === "bottomLeft",
          "end-0": btnPosition === "bottomRight",
        })}
      />
    </div>
  );
};

export default FloatingPopup;
